import React from 'react';
import TableauReport from 'tableau-react-embed';
import { connect } from 'react-redux';
import { Circles } from '../common/loadingComponent';
import { withRouter } from 'react-router';
import { apiGet, apiPost, getHostApi } from '../../store/apiWrapper';
import { writeErr } from '../common/logger';
import Message from '../common/message';
import { Translate, withLocalize } from "react-localize-redux";
import { isNullOrUndefined } from "../../store/storeFunctions";
import { getElementBoundingRect, getElementHeight, getClientWindowHeight, getElementVal } from '../../store/almightyElementWrapper';
import { hasPermission } from '../../store/apiWrapper';

class TableauComponent extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            loading: true,
            tableauSettings:{}
        }   
    }
   
    height = () => {
        const ch = getClientWindowHeight();
        const vars = [
            getElementHeight({ className: 'page-nav' }),
            getElementHeight({ className: 'report-selection-menu' }),
            getElementHeight({ className: 'report-selection-menu-line-wrapper' }),
            getElementHeight({ className: 'entity-row-wrapper'}),
            getElementHeight({ className: 'page-footer' })
        ];
        return ch - vars.reduce((a, b) => a + b, 0);
    }

    render() {
        const h = this.height();
        
        if (!(!this.state.loading && this.state.tableauSettings))
            return (<Circles />);
        if (this.state.tableauSettings.token == -1)
            return (
                <React.Fragment>
                    {this.showError(this.props.translate)}
                </React.Fragment>
            )

        return (
            <div className="relation-chart-root" style={{ zIndex: 10, display: 'flex', flex: '1 1 auto', flexDirection: 'column', overflow: 'auto', height: `${h}px` }}>
                {hasPermission(null, "EmbeddedItrade") && 
                    <div>
                        {this.renderTableau(h)}
                    </div>
                }
            </div>
        );
    }

    renderTableau(h){
        return (
            <React.Fragment>
                <TableauReport url={this.state.tableauSettings.url}
                        token={this.state.tableauSettings.token}
                        options={{ height: `${h}px`, width: '100%'}}
                        query="?:embed=yes&:comments=no&:toolbar=yes&:refresh=yes&:showShareOptions=false">
                </TableauReport>
            </React.Fragment>
        )
    }

    showError = (error) => {
        if (error === null || error === undefined) {
            return "";
        }
        return (
            <div className="error-container" style={{paddingTop: '1em'}}>
                <Message type={'warning'} message={<Translate id="Tableau.Auth.Error" options={{ renderInnerHtml: true }} />} />
            </div>
        );
    }

    componentDidMount() {
        apiGet(`${getHostApi()}/api/tableau/get-settings`,
            null,
            (success) => {
                if (!isNullOrUndefined(success) && !isNullOrUndefined(success.data))
                    this.setState({ tableauSettings: success.data, loading: false })
            },
            (error) => {
                this.setState({loading: false });
                writeErr(error)}
        );
    }
}

export default withRouter(withLocalize(connect(
    state => (state.layout),
)(TableauComponent)));